var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "validators_data_table"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.validators,
      "headers": _vm.headers,
      "mobile-breakpoint": 600,
      "dark": _vm.$root.theme === 'night',
      "multi-sort": false,
      "items-per-page": 10,
      "calculate-widths": ""
    },
    scopedSlots: _vm._u([{
      key: "item.nodeID",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('p', {
          staticClass: "value nodeid"
        }, [_vm._v(" " + _vm._s(item.nodeID) + " ")])];
      }
    }, {
      key: "item.stakeAmount",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('p', {
          staticClass: "value stake after-dcm"
        }, [_vm._v(" " + _vm._s(_vm.toDCM(item.stakeAmount)) + " ")])];
      }
    }, {
      key: "item.delegators",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.delegators ? _c('p', {
          staticClass: "value delegators"
        }, [_vm._v(" " + _vm._s(item.delegators.length) + " ")]) : _c('p', {
          staticClass: "value delegators"
        }, [_vm._v("0")])];
      }
    }, {
      key: "item.uptime",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('p', {
          staticClass: "value uptime"
        }, [_vm._v(" " + _vm._s(parseFloat(item.uptime.toString() * 100).toFixed(2)) + " % ")])];
      }
    }, {
      key: "item.endTime",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('p', {
          staticClass: "value endtime"
        }, [_vm._v(" " + _vm._s(_vm.toNow(item.endTime)) + " ")])];
      }
    }, {
      key: "item.potentialReward",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('p', {
          staticClass: "value reward after-dcm"
        }, [_vm._v(" " + _vm._s(_vm.toDCM(item.potentialReward)) + " ")])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }